import React from 'react';
import NewMobileVerificationFlow from '../../user-flow/individual/revampedUserFlow/NewMobileVerificationFlow';
import RecipientScreen from '../forex-pages/recipient';
import AadharVerification from '../forex-pages/aadhar-verification';
import SendMoney from '../forex-pages/send-money-calculator';
import PanVerificationScreen from '../forex-pages/pan-verification';
import VideoKycScreen from '../forex-pages/video-kyc';
import ReKycScreen from '../forex-pages/re-verify-kyc';
import SelectBankScreen from '../forex-pages/select-bank';
import UploadDocumentScreen from '../forex-pages/upload-documents';
import ESignin from '../forex-pages/e-signin';
import FundYourTransferScreen from '../forex-pages/verify-payment';
import AcknowledgementScreen from '../forex-pages/acknowledgement';
import PaymentReview from '../forex-pages/payment-review-screen';
import NFCrossSellingForm from '../forex-pages/cross-selling/NFCrossSellingForm';
import NFCrossSelling from '../forex-pages/cross-selling/NFCrossSelling';
import NFCrossSellingSuccess from '../forex-pages/cross-selling/NFCrossSellingSuccess';

import {
  ADD_PAYEE_URL,
  HISTORY_URL,
  NIUM_FOREX_URL,
  PAYEE_LIST_URL,
  USER_PROFILE_URL,
  REFERRAL_URL,
  NIUM_FOREX_AADHAR_CALLBACK_URL,
  NIUM_FOREX_VIDEO_KYC_CALLBACK_URL,
  HELP_CENTER,
  NIUM_FOREX_ESIGN_IN_CALLBACK_URL
} from '../../../utils/constants';

export const NF_SCREENS = {
  mobile_verification: 'mobile_verification',
  send_money: 'send_money',
  recipient: 'recipient',
  pan_verification: 'pan_verification',
  video_kyc: 'video_kyc',
  re_kyc: 're_kyc',
  fund_transfer: 'fund_transfer',
  select_bank: 'select_bank',
  aadhar_verification: 'aadhar_verification',
  upload_documents: 'upload_documents',
  e_sign_in: 'e_sign_in',
  transaction_summary: 'transaction_summary',
  cross_selling_form: 'cross_selling_form',
  cross_selling: 'cross_selling',
  cross_selling_success: 'cross_selling_success',
  acknowledgement: 'acknowledgement'
};

export const NIUM_FOREX_SCREENS: any = {
  mobile_verification: {
    name: NF_SCREENS.mobile_verification,
    component: <NewMobileVerificationFlow />
  },
  send_money: {
    name: NF_SCREENS.send_money,
    component: <SendMoney />
  },
  recipient: {
    name: NF_SCREENS.recipient,
    component: <RecipientScreen />
  },
  aadhar_verification: {
    name: NF_SCREENS.aadhar_verification,
    component: <AadharVerification />
  },
  pan_verification: {
    name: NF_SCREENS.pan_verification,
    component: <PanVerificationScreen />
  },
  video_kyc: {
    name: NF_SCREENS.video_kyc,
    component: <VideoKycScreen />
  },
  fund_transfer: {
    name: NF_SCREENS.fund_transfer,
    component: <FundYourTransferScreen />
  },
  select_bank: {
    name: NF_SCREENS.select_bank,
    component: <SelectBankScreen />
  },
  upload_documents: {
    name: NF_SCREENS.upload_documents,
    component: <UploadDocumentScreen />
  },
  e_sign_in: {
    name: NF_SCREENS.e_sign_in,
    component: <ESignin />
  },

  acknowledgement: {
    name: NF_SCREENS.acknowledgement,
    component: <AcknowledgementScreen />
  },
  re_kyc: {
    name: NF_SCREENS.re_kyc,
    component: <ReKycScreen />
  },
  transaction_summary: {
    name: NF_SCREENS.transaction_summary,
    component: <PaymentReview />
  },
  cross_selling_form: {
    name: 'cross_selling_form',
    component: <NFCrossSellingForm />
  },
  cross_selling: {
    name: 'cross_selling',
    component: <NFCrossSelling />
  },
  cross_selling_success: {
    name: 'cross_selling_success',
    component: <NFCrossSellingSuccess />
  }
};

export const NIUM_FOREX_UNSAVED_CHANGES_ROUTES = [
  NF_SCREENS.recipient,
  NF_SCREENS.upload_documents,
  NF_SCREENS.aadhar_verification,
  NF_SCREENS.re_kyc,
  NF_SCREENS.pan_verification
];

export const NF_ALLOWED_ROUTES = [
  ADD_PAYEE_URL,
  PAYEE_LIST_URL,
  NIUM_FOREX_URL,
  HISTORY_URL,
  USER_PROFILE_URL,
  REFERRAL_URL,
  NIUM_FOREX_AADHAR_CALLBACK_URL,
  NIUM_FOREX_VIDEO_KYC_CALLBACK_URL,
  HELP_CENTER,
  NIUM_FOREX_ESIGN_IN_CALLBACK_URL
];

export const NF_CALLBACK_URLS = {
  aadharCallbackUrl: 'aadhar-verification-callback',
  videoKycCallbackUrl: 'video-verification-callback',
  eSignInCallbackUrl: 'es-callback'
};

//Whole url except domain name
export const CALLBACKS_URL = {
  forexAadharCallbackURL: `/nium-forex/aadhar-verification-callback`,
  forexVideoCallbackURL: `/nium-forex/video-verification-callback`,
  eSignInCallbackUrl: '/nium-forex/es-callback'
};
